module.exports = __webpack_public_path__ + "static/media/green.2a917322.svg";